module.exports = __webpack_public_path__ + "static/media/plan-wom-400gb.9c023d82.svg";